import { fetchWrapper, objectToQueryParams } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/billing';

  static async pay(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/${id}/download`;
    return await fetchWrapper.get(url);
  }

  static async findUsers(filters) {
    const url = `${this.baseUrl}/users?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }
}
